var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54",
  transform: "translate(0.248)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_35",
  "data-name": "Rectangle 35",
  width: 40,
  height: 40,
  rx: 20,
  transform: "translate(-0.248)",
  fill: "#008c45"
}), /*#__PURE__*/React.createElement("path", {
  id: "instagram3",
  d: "M62.749,11.109a2.222,2.222,0,0,0-1.629-.68H47.737a2.321,2.321,0,0,0-2.309,2.309V26.12a2.321,2.321,0,0,0,2.309,2.309H61.12a2.321,2.321,0,0,0,2.308-2.309V12.738A2.222,2.222,0,0,0,62.749,11.109ZM51.891,16.915a3.7,3.7,0,0,1,5.109,0,3.426,3.426,0,0,1,0,4.957,3.695,3.695,0,0,1-5.109,0,3.426,3.426,0,0,1,0-4.957Zm9.5,8.725a.683.683,0,0,1-.211.51.7.7,0,0,1-.5.205H48.147a.7.7,0,0,1-.715-.715V18.046h1.652a5.044,5.044,0,0,0-.234,1.535,5.146,5.146,0,0,0,1.641,3.838,5.476,5.476,0,0,0,3.949,1.588,5.633,5.633,0,0,0,2.813-.727,5.47,5.47,0,0,0,2.039-1.975,5.192,5.192,0,0,0,.75-2.725,5.045,5.045,0,0,0-.235-1.535h1.582V25.64Zm0-10.465a.8.8,0,0,1-.809.809H58.541a.8.8,0,0,1-.809-.809V13.242a.787.787,0,0,1,.234-.568.772.772,0,0,1,.574-.24H60.58a.771.771,0,0,1,.574.24.786.786,0,0,1,.235.568Z",
  transform: "translate(-34.676 0.571)",
  fill: "#fff"
}));
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.aff6b0780d81fae642f72ea3c64322b6.svg";
export { ForwardRef as ReactComponent };